import translate from '@/lib/intl/translate';
import DonationExtSources from './DonationExtSources';

const DonationExtSourcesNames: Record<DonationExtSources, string> = {
  [DonationExtSources.CLASSY_SUPPORTER]: translate('INTEGRATIONS_CLASSY'),
  [DonationExtSources.EVENTBRITE]: translate('INTEGRATIONS_EVENTBRITE'),
  [DonationExtSources.INSTIL]: translate('INTEGRATIONS_INSTIL'),
  [DonationExtSources.PLEDGE]: translate('INTEGRATIONS_PLEDGE'),
  [DonationExtSources.PLEDGE_TO]: translate('INTEGRATIONS_PLEDGE'),
  [DonationExtSources.SALESFORCE]: translate('INTEGRATIONS_SALESFORCE'),
  [DonationExtSources.STRIPE_CUSTOMER]: translate('INTEGRATIONS_STRIPE'),
  [DonationExtSources.STRIPE]: translate('INTEGRATIONS_STRIPE'),
} as const;

export default DonationExtSourcesNames;
